/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableBarcode.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1032
 * ---
 * Description:
 */

import Pamela from '@revodigital/pamela';
import {
  action,
  computed,
  makeObservable,
  observable
}             from 'mobx';
import {
  defaultSetterOptions,
  ObservableSetterOptions,
  ObservableShape
}             from './ObservableShape';

export class ObservableBarcode extends ObservableShape<Pamela.Barcode> {
  @observable
  private _code: string;
  @observable
  private _encoding: string;
  @observable
  private _codeLineWidth: number;
  @observable
  private _displayValue: boolean;
  @observable
  private _backgroundColor: string;
  @observable
  private _contentFontSize: number;

  constructor(shape: Pamela.Barcode, editor: any) {
    super(shape, editor);

    this._code = shape.code();
    this._encoding = shape.encoding();
    this._codeLineWidth = shape.codeLineWidth();
    this._displayValue = shape.displayValue();
    this._backgroundColor = shape.backgroundColor();
    this._contentFontSize = shape.contentFontSize();

    makeObservable(this);
  }

  @computed
  public get code() {
    return this._code;
  }

  @computed
  public get backgroundColor() {
    return this._backgroundColor;
  }

  @computed
  public get encoding() {
    return this._encoding;
  }

  @computed
  public get displayValue() {
    return this._displayValue;
  }

  @computed
  public get contentFontSize() {
    return this._contentFontSize;
  }

  @computed
  public get codeLineWidth() {
    return this._codeLineWidth;
  }

  @action
  public setDisplayedValue(value: boolean, options: ObservableSetterOptions = defaultSetterOptions) {
    this._displayValue = value;

    if (options.applyToPamelaShape) {
      this.pamelaShape__nonObservable.displayValue(value);
      this.pamelaShape__nonObservable.draw();
    }
  }

  @action
  public setCode(code: string, options: ObservableSetterOptions = defaultSetterOptions) {
    this._code = code;

    if (options.applyToPamelaShape)
      this.pamelaShape__nonObservable.code(code);
    this.editor.history.takeSnapshot();
  }

  @action
  public setBackgroundColor(color: string, options: ObservableSetterOptions = defaultSetterOptions) {
    this._backgroundColor = color;

    if (options.applyToPamelaShape)
      this.pamelaShape__nonObservable.backgroundColor(color);
    this.editor.history.takeSnapshot();
  }

  @action
  public setEncoding(encoding: string, options: ObservableSetterOptions = defaultSetterOptions) {
    this._encoding = encoding;

    if (options.applyToPamelaShape)
      this.pamelaShape__nonObservable.encoding(encoding);
    this.editor.history.takeSnapshot();
  }

  @action
  public setCodeLineWidth(codeLineWidth: number, options: ObservableSetterOptions = defaultSetterOptions) {
    this._codeLineWidth = codeLineWidth;

    if (options.applyToPamelaShape)
      this.pamelaShape__nonObservable.codeLineWidth(codeLineWidth);
    this.editor.history.takeSnapshot();
  }

  @action
  public setContentFontSize(contentFontSize: number, options: ObservableSetterOptions = defaultSetterOptions) {
    this._contentFontSize = contentFontSize;

    if (options.applyToPamelaShape)
      this.pamelaShape__nonObservable.contentFontSize(contentFontSize);
    this.editor.history.takeSnapshot();
  }
}
